import SignaturePad from "signature_pad";

export default function registerSignaturePad(Alpine) {
  Alpine.data("signaturePad", () => ({
    method: "typed",
    pad: null,
    typedName: "",
    drawnHasInk: false,
    signatureDataUrl: "",
    _resizeListener: null,

    init() {
      this.$nextTick(() => {});
    },

    initPad() {
      const canvas = this.$refs.pad;
      if (!canvas || this.pad) return;

      this.pad = new SignaturePad(canvas, {
        backgroundColor: "rgba(255,255,255,1)",
        penColor: "rgb(15, 23, 42)"
      });
      this.pad.addEventListener("endStroke", () => {
        this.drawnHasInk = !this.pad.isEmpty();
      });
      this.resizeCanvas(canvas);

      this._resizeListener = () => this.resizeCanvas(canvas);
      window.addEventListener("resize", this._resizeListener);
    },

    resizeCanvas(canvas) {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const rect = canvas.getBoundingClientRect();
      const cssWidth = rect.width || canvas.clientWidth || 320;
      const cssHeight = parseFloat(canvas.style.height) || 160;

      // Lock the CSS-rendered size so resize is idempotent.
      canvas.style.height = cssHeight + "px";
      canvas.width = Math.round(cssWidth * ratio);
      canvas.height = Math.round(cssHeight * ratio);

      const ctx = canvas.getContext("2d");
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(ratio, ratio);

      if (this.pad) {
        const data = this.pad.toData();
        this.pad.clear();
        if (data && data.length) this.pad.fromData(data);
      }
    },

    // Strokes and not an image: resizeCanvas keeps only strokes, so pixels would vanish
    // on the next resize with the ink flag still set.
    strokes() {
      return this.method === "drawn" && this.pad ? this.pad.toData() : null;
    },

    // A drawing brought back after a page load, so a customer need not draw it twice.
    restoreDrawing(strokes) {
      this.initPad();
      if (!this.pad) return;

      this.pad.fromData(strokes);
      this.drawnHasInk = !this.pad.isEmpty();
    },

    clearPad() {
      if (this.pad) this.pad.clear();
      this.signatureDataUrl = "";
      this.drawnHasInk = false;
    },

    captureSignature() {
      if (this.method === "drawn" && this.pad && !this.pad.isEmpty()) {
        this.signatureDataUrl = this.pad.toDataURL("image/png");
      } else {
        this.signatureDataUrl = "";
      }
    },

    get canSubmit() {
      const store = Alpine.store("signing");
      const acksOk = !store || store.allAcked;
      if (!acksOk) return false;

      if (this.method === "typed") {
        return this.typedName.trim().length >= 2;
      }
      if (this.method === "drawn") {
        return this.drawnHasInk;
      }
      return false;
    }
  }));
}
